import React from "react";
import "./DeleteModal.css";
import MainButtonComp from "../Buttons/MainButtonComp";

const DeleteModal = ({ text, onClick, disabled }) => {
  return (
    <>
      <div>
        <MainButtonComp
          disabled={disabled}
          text={text ?? "this record  "}
          delBtn
          onClick={() => {}}
          PopConfirmOnclick={onClick}
        />
      </div>
    </>
  );
};

export default DeleteModal;
